var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-switch',{staticClass:"AgTableSwitch",attrs:{"dense":"","hide-details":"","input-value":_vm.valueProxy},nativeOn:{"!click":function($event){$event.stopPropagation();_vm.valueProxy = !_vm.valueProxy}}})
}
var staticRenderFns = []

export { render, staticRenderFns }